"use client";

import "@xyflow/react/dist/style.css";
import React, { useState, useEffect } from "react";
import { ReactFlowProvider } from "@xyflow/react";
import { FlowCanvas } from "./FlowCanvas";
import { DbSchemaEditor } from "./DbSchemaEditor";
import type { DbSchema } from "./types";
import { loadDbSchema, saveDbSchema } from "./persistence";

type Tab = "flow" | "db";

export default function IdeaScratcherPlayground() {
  const [activeTab, setActiveTab] = useState<Tab>("flow");
  const [dbSchema, setDbSchema] = useState<DbSchema>({ tables: [] });

  useEffect(() => {
    // Load browser-only storage after the server and client have hydrated.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setDbSchema(loadDbSchema());
  }, []);

  const handleDbChange = (schema: DbSchema) => {
    setDbSchema(schema);
    saveDbSchema(schema);
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 dark:border-white/10">
      {/* Tab bar */}
      <div className="flex border-b border-gray-200 bg-white px-3 dark:border-white/10 dark:bg-zinc-950">
        {(
          [
            ["flow", "Workflow"],
            ["db", "Datenbank"],
          ] as [Tab, string][]
        ).map(([id, label]) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            className={`-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition ${
              activeTab === id
                ? "border-amber-400 text-amber-500 dark:text-amber-400"
                : "border-transparent text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
            }`}
          >
            {label}
          </button>
        ))}
      </div>

      {activeTab === "flow" && (
        <ReactFlowProvider>
          <FlowCanvas dbSchema={dbSchema} onDbSchemaChange={handleDbChange} />
        </ReactFlowProvider>
      )}
      {activeTab === "db" && (
        <DbSchemaEditor schema={dbSchema} onChange={handleDbChange} />
      )}
    </div>
  );
}
